import getCount from './getCount';

// ----------------------------------------------------------------------------

function getDimension(element: HTMLElement): Record<string, any> {
    const count = getCount(element);
    const width = element.clientWidth;
    const height = element.clientHeight;

    return {
        width: count.columnCount ? width / count.columnCount : 0,
        height: count.rowCount ? height / count.rowCount : 0,
    };
}

// ----------------------------------------------------------------------------

export default getDimension;
